export default "__VITE_ASSET__CNn3Ta5I__"